{"VITE_API_KEY":"IP93ZDX9-EMWGKOFX-4OSSLHXL","VITE_API_PROJECT_KEY":"api-wis-salzgitter"}